import { Button } from '@mui/material'
import React from 'react'
import { i18n } from '../../domain/index'
import css from './ErrorMessage.css'
type ErrorMessageProps = {
  message: string
  refetch?: (...args: Array<any>) => any
}

const ErrorMessage = ({ message, refetch }: ErrorMessageProps) => (
  <div className={css.component}>
    <p className={css.text}>{message}</p>
    {refetch ? (
      <Button color='primary' variant='contained' onClick={refetch}>
        {i18n.t('buttons.tryAgain')}
      </Button>
    ) : null}
  </div>
)

export default ErrorMessage
